import { IconName } from '../enums/icon-enum';
import { InfoMessageModalData } from '../interfaces/info-message-modal-data.interface';

export const PASSWORD_SUCCESS_MODAL_CONFIG: InfoMessageModalData = {
  title: 'passwordGenerationSuccessModal.title',
  infoText: 'passwordGenerationSuccessModal.infoText',
  iconName: IconName.CONFIRMATION_ICON,
  action: 'passwordGenerationSuccessModal.close',
};
